// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__VYIfY","disabled":"Icon_disabled__o2Nbi"};